import { render, staticRenderFns } from "./StatementFormulations.vue?vue&type=template&id=5e328dec&scoped=true"
import script from "./StatementFormulations.vue?vue&type=script&lang=js"
export * from "./StatementFormulations.vue?vue&type=script&lang=js"
import style0 from "./StatementFormulations.vue?vue&type=style&index=0&id=5e328dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e328dec",
  null
  
)

export default component.exports